import visit from 'unist-util-visit'

import { LiteralVisitNode, VisitNode } from './types'

export const brToSlashN = () => {
    function transformer(tree: VisitNode) {
        visit(tree, 'html', (node: LiteralVisitNode) => {
            if (node.value === '<br />') {
                node.value = '\n'
                node.type = 'text'
            }
        })
    }

    return transformer
}
